// extracted by mini-css-extract-plugin
export default {"wrapper":"xEeMl9tg6YAnuhAq4PZy"};